export default __webpack_public_path__ + "static/media/mentoring-waba-banner.0fb0d9e0.png";